export const SchedulingWidgetId = 'SchedulingWidget';

export enum SchedulingWidgetAttributes {
  VISIBLE_FROM = 'visibleFrom',
  VISIBLE_UNTIL = 'visibleUntil',
  CHILDREN = 'children',
}
